class Setup { }

Setup.selectorType = 'css_class';
Setup.selectorPrefix = 'js';

export default Setup;
